import React, { useCallback, useState } from "react";
import Waitable from "../../common/waitable/waitable";
import { useAppSelector } from "../../../redux/store";
import { GameStatus } from "../../../types/game-status";
import { useTranslation } from "react-i18next";
import useInterval from "../../common/use-interval/use-interval";
import StoryTransition from "./story-transition";
import StoryTime from "./story-time";
import { now } from "../../../time";
import { selectPlayer, selectGameStatus, selectCountdown } from "../../../redux/selectors";

const tickInterval = 200;

export enum StoryState {
  WRITING,
  SAVING,
}

const Story = () => {
  const { t } = useTranslation("game");

  const player = useAppSelector(selectPlayer);
  const gameStatus = useAppSelector(selectGameStatus);
  const countdown = useAppSelector(selectCountdown);

  const isTransition = gameStatus === GameStatus.GameStatusStoryWriteTransition;
  // submission_end of 0 means timing not set yet - treat as far future
  const submissionEnd = player?.submission?.submission_end;
  const end = submissionEnd && submissionEnd > 0 ? submissionEnd : Number.MAX_SAFE_INTEGER;

  const [storyState, setStoryState] = useState<StoryState>(StoryState.WRITING);

  const handleStoryState = useCallback(() => {
    // Only track WRITING vs SAVING state (transition is handled by game status)
    setStoryState(end - now() < 0 ? StoryState.SAVING : StoryState.WRITING);
  }, [end]);

  useInterval(handleStoryState, tickInterval);

  return (
    <Waitable
      waitingFor={[GameStatus.GameStatusPostStoryWrite]}
      waitHeader={t("storyTime.headers.waiting")}
    >
      {isTransition ? (
        <StoryTransition deadline={countdown.deadline} />
      ) : (
        <StoryTime storyState={storyState} deadline={end} />
      )}
    </Waitable>
  );
};
export default Story;
